module.exports = __webpack_public_path__ + "img/bg_top_round.6d5ba003.png";